import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";
 
const GetFolderAccessRights = urlConfig.GetFolderAccessRights;
const SaveFolderAccessRightsPermission = urlConfig.SaveFolderAccessRightsPermission;

export const getFolderAccessRights = async (params: any) => {
  try {
    const response = await postCall(GetFolderAccessRights, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const saveFolderAccessRightsPermission = async (params: any) => {
  try {
    const response = await postCall(SaveFolderAccessRightsPermission, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
